export function extractGoogleMapsEmbedded(iframe) {
  const srcRegExp = /\ssrc="([^"]*)"/i
  const pbRegExp = /^https?:\/\/www\.google\.com\/maps\/embed\?pb=(.*)/i
  const src = srcRegExp.exec(iframe)
  const matching = src ? pbRegExp.exec(src[1]) : null
  return matching ? matching[1].replace(/#/g, '%23').replace(/&/g, '%26') : undefined
}
